import React from 'react';
import { Icon } from 'antd';
import { NavLink } from 'react-router-dom';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  displayName?: string;
  formattedName?: string;
  redirectUrl?: string;
  localPath?: string;
  iconType?: string;
  iconAfter?: boolean;
  imageUrl?: string;
  imageAlt?: string;
  style?: string;
  onClick?: () => void;
}

const Link: React.SFC<IProps> = ({ 
  displayName,
  formattedName, 
  redirectUrl, 
  localPath, 
  iconType, 
  iconAfter, 
  imageUrl, 
  imageAlt,
  style,
  onClick,
}) => {

  const content = (
    <>
      { iconType && !iconAfter && <Icon type={ iconType } /> }
      { displayName && <FormattedText { ... { displayName, formattedName } } /> }
      { iconType && iconAfter && <Icon type={ iconType } /> }
      { imageUrl && <img src={ imageUrl } alt={ imageAlt } /> }
    </>
  );

  if (localPath) {
    return <NavLink to={ localPath } className={ style }>{ content }</NavLink>;
  }

  if (redirectUrl) {
    return <a href={ redirectUrl } target='_blank' className={ style }>{ content }</a>;
  }

  return <span onClick={ onClick } className={ style }>{ content }</span>;
};
  
export default Link;


// WEBPACK FOOTER //
// ./src/components/Shared/Link/Link.tsx